class ProductDetailFooterScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    setTimeout(() => {
      const observer = new IntersectionObserver(this.onEntry.bind(this))

      observer.observe(this.externalEls.intersection.element)

      this.setHeight()
    }, 1500)
  }

  onEntry ([entry], observer) {
    if (entry.isIntersecting) {
      this.classList.add('prd-Detail_ColumnFooter-sticky')
      this.style.opacity = '1'
    } else if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
      this.classList.add('prd-Detail_ColumnFooter-sticky')
      this.style.opacity = '1'
    } else if (!entry.isIntersecting && entry.boundingClientRect.y > 0) {
      this.classList.remove('prd-Detail_ColumnFooter-sticky')
      this.style.opacity = '1'
    }
  }

  setHeight () {
    if (!this.externalEls?.column?.exists) return

    this.closest('.prd-Detail_Column').style.setProperty(
      '--StickyFooter_Height',
      `${this.offsetHeight}px`,
    )
  }
}

if (!customElements.get('product-detail-footer-scroll')) {
  customElements.define(
    'product-detail-footer-scroll',
    ProductDetailFooterScroll,
  )
}
